import ClassList from './ClassList';
import Services from "./Services";

export default class Handler {
    $url;
    $classList;

    constructor() {
        this.$classList = ClassList;
        this.$url = Services?.URL?.path();
        if (!this.$url) {
            throw new Error('URL Service Not Fond...!');
        }
    }

    initMainClass() {
        const $initial_any_page = this.$classList['default']?.instance;
        if (typeof $initial_any_page !== 'undefined') {
            $initial_any_page?.main();
        }
    }

    fire() {
        const $this = this;
        this.initMainClass();
        let pagePath = $this.$url.substring(1).replace(/\d/g, '');
        for (const $class_name in this.$classList) {
            if ($class_name === 'default') {
                continue;
            }
            let $classAttr = this.$classList[$class_name];
            if (typeof $classAttr !== 'undefined') {
                const class_instance = $classAttr?.instance;
                let class_urls = $classAttr?.urls;
                class_urls = class_urls.map((url) => {
                    if (url.indexOf('/**') > -1) {
                        const regex = new RegExp(`(${url.replace('/**', '')}\\/*?)+(\\w.*)`, 'g')
                        pagePath = pagePath.replace(regex, '$1')
                        return url.replace('**', '')
                    }
                    return url
                })
                if (class_urls && class_urls.includes(pagePath)) {
                    class_instance?.main();
                }
            }
        }
    }
}

export function PageHandler() {
    return new Handler();
}